/* eslint-disable no-empty-pattern */

const defaultImportDetails = {
  fileName: '',
  guestStatus: 1,
  deleteExistingGuests: false,
};

export default {
  namespaced: true,
  state: {
    dialogIsVisible: false,
    operationIsOngoing: false,
    isGeneratingGuestsToImport: false,
    isImportingGuests: false,
    selectedFiles: null,
    invalidRowCount: 0,
    importDetails: { ...defaultImportDetails },
    selectedColumns: [],
    guestsToImport: [],
    importFileData: {
      fileData: [],
      fileColumns: [],
      invalidRowsIndexLimit: 0,
    },
  },
  getters: {
    importFileDataIsAvailable: (state) => state.importFileData.fileData.length !== 0,
    validRowCount: (state) => state.importFileData.fileData.length - state.invalidRowCount,
    columnSelectionIsValid: (state) => state.selectedColumns.includes('firstName')
      || state.selectedColumns.includes('lastName'),
  },
  mutations: {
    RESET_GUEST_IMPORT_STATE(state) {
      state.dialogIsVisible = false;
      state.selectedFiles = null;
      state.invalidRowCount = 0;
      state.importDetails = { ...defaultImportDetails };
      state.parsingIsOngoing = false;
      state.selectedColumns = [];
      state.guestsToImport = [];
      state.importFileData.fileData = [];
      state.importFileData.fileColumns = [];
    },
    SET_DIALOG_IS_VISIBLE(state, dialogIsVisible) {
      state.dialogIsVisible = dialogIsVisible;
    },
    SET_OPERATION_IS_ONGOING(state, operationIsOngoing) {
      state.operationIsOngoing = operationIsOngoing;
    },
    SET_IS_GENERATING_GUESTS_TO_IMPORT(state, isGeneratingGuestsToImport) {
      state.isGeneratingGuestsToImport = isGeneratingGuestsToImport;
    },
    SET_IS_IMPORTING_GUESTS(state, isImportingGuests) {
      state.isImportingGuests = isImportingGuests;
    },
    SET_SELECTED_FILES(state, selectedFiles) {
      state.selectedFiles = selectedFiles;
    },
    SET_INVALID_ROW_COUNT(state, invalidRowCount) {
      state.invalidRowCount = invalidRowCount;
    },
    SET_SELECTED_COLUMNS(state, selectedColumns) {
      state.selectedColumns = selectedColumns;
    },
    SET_IMPORT_DETAILS(state, importDetails) {
      state.importDetails = importDetails;
    },
    SET_GUESTS_TO_IMPORT(state, guestsToImport) {
      state.guestsToImport = guestsToImport;
    },
    SET_IMPORT_FILE_DATA(state, { fileData, fileColumns, invalidRowsIndexLimit }) {
      state.importFileData.fileData = fileData;
      state.importFileData.fileColumns = fileColumns;
      state.importFileData.invalidRowsIndexLimit = invalidRowsIndexLimit;
    },
    // SET_IMPORT_PREVIEW_DATA(state, { previewRows, hiddenRowsCount, previewLastRow, previewLastRowIndex, fileColumns }) {
    //   state.importPreviewData.previewRows = previewRows;
    //   state.importPreviewData.hiddenRowsCount = hiddenRowsCount;
    //   state.importPreviewData.previewLastRow = previewLastRow;
    //   state.importPreviewData.previewLastRowIndex = previewLastRowIndex;
    //   state.importPreviewData.fileColumns = fileColumns;
    // },
  },
  actions: {
    resetGuestImportState: ({ commit }) => {
      commit('RESET_GUEST_IMPORT_STATE');
    },
    updateDialogIsVisible: ({ commit }, dialogIsVisible) => {
      commit('SET_DIALOG_IS_VISIBLE', dialogIsVisible);
    },
    updateComponentIsRendered: ({ commit }, componentIsRendered) => {
      commit('SET_COMPONENT_IS_RENDERED', componentIsRendered);
    },
    updateSelectedFiles: ({ commit }, selectedFiles) => {
      commit('SET_SELECTED_FILES', selectedFiles);
    },
    updateInvalidRowCount: ({ commit }, invalidRowCount) => {
      commit('SET_INVALID_ROW_COUNT', invalidRowCount);
    },
    updateSelectedColumns: ({ commit }, selectedColumns) => {
      commit('SET_SELECTED_COLUMNS', selectedColumns);
    },
    updateImportDetails: ({ commit }, importDetails) => {
      commit('SET_IMPORT_DETAILS', importDetails);
    },
    updateImportFileData: ({ commit }, importFileData) => {
      commit('SET_IMPORT_FILE_DATA', importFileData);
    },
    updateIsImportingGuests: ({ commit }, isImportingGuests) => {
      commit('SET_IS_IMPORTING_GUESTS', isImportingGuests);

      return Promise.resolve();
    },
    updateImportPreviewData: ({ commit }, importPreviewData) => {
      commit('SET_IMPORT_PREVIEW_DATA', importPreviewData);
    },
    generateGuestData: ({ state, commit }) => { // TODO: Move to Service worker?
      commit('SET_IS_GENERATING_GUESTS_TO_IMPORT', true);

      const emailNeedle = /^.+@.+\..+$/;
      const guestsToImport = [];
      let invalidRowCount = 0;

      const rowIndexStart = state.importFileData.invalidRowsIndexLimit === -1 ? 0
        : state.importFileData.invalidRowsIndexLimit;
      for (let rowIndex = rowIndexStart; rowIndex < state.importFileData.fileData.length; rowIndex += 1) {
        const now = new Date();
        const guest = {
          firstName: '?',
          lastName: '?',
          creationTime: now,
          modificationTime: now,
          source: 1,
          status: state.importDetails.guestStatus,
        };
        if (state.importDetails.guestStatus === 1) {
          guest.attendingTime = now;
        }

        for (let colIndex = 0; colIndex < state.importFileData.fileData[rowIndex].length; colIndex += 1) {
          if (state.importFileData.fileData[rowIndex][colIndex]) {
            const cellData = state.importFileData.fileData[rowIndex][colIndex];
            const cellDataLowerCase = cellData.toString().toLowerCase();

            if (state.selectedColumns[colIndex] === 'vip') {
              if (!cellDataLowerCase.includes('false') && !cellDataLowerCase.includes('0')) guest[state.selectedColumns[colIndex]] = true;
            } else if (state.selectedColumns[colIndex] === 'email') {
              if (emailNeedle.test(cellData)) guest[state.selectedColumns[colIndex]] = cellData.replace(/\s+/g, '');
            } else if (state.selectedColumns[colIndex] === 'status') {
              if (cellDataLowerCase.includes('no') || cellDataLowerCase.includes('-')) guest[state.selectedColumns[colIndex]] = 0;
              else if (cellDataLowerCase.includes('attending') || cellDataLowerCase.includes('accepted')) guest[state.selectedColumns[colIndex]] = 1;
              else if (cellDataLowerCase.includes('checked-in')) guest[state.selectedColumns[colIndex]] = 2;
              else if (cellDataLowerCase.includes('checked-out')) guest[state.selectedColumns[colIndex]] = 3;
              else if (cellDataLowerCase.includes('invited') || cellDataLowerCase.includes('delivered')) guest[state.selectedColumns[colIndex]] = 4;
              else if (cellDataLowerCase.includes('declined')) guest[state.selectedColumns[colIndex]] = 5;
              else {
                const statusValue = parseInt(cellData, 10);
                if (!Number.isNaN(statusValue)) guest[state.selectedColumns[colIndex]] = parseInt(cellData, 10);
              }
            } else if (state.selectedColumns[colIndex] === 'totalExtraGuests') {
              const parsedNumber = parseInt(cellData, 10);
              if (!Number.isNaN(parsedNumber)) guest[state.selectedColumns[colIndex]] = parsedNumber;
            } else if (state.selectedColumns[colIndex] === 'barcodeValue' && cellData.toString().trim() !== '') {
              guest[state.selectedColumns[colIndex]] = cellData.toString().replace(/\s+/g, '');
            } else if (state.selectedColumns[colIndex] !== '' && cellData.toString().trim() !== '') {
              guest[state.selectedColumns[colIndex]] = cellData.toString().trim();
            }
          }
        }

        if (guest.firstName === '?' && guest.lastName === '?') { // Skip guest that has no first and last name
          invalidRowCount += 1;
        } else if (rowIndex >= state.importFileData.invalidRowsIndexLimit) {
          guestsToImport.push(guest);
        }
      }

      if (state.importFileData.invalidRowsIndexLimit !== -1) {
        invalidRowCount += state.importFileData.invalidRowsIndexLimit;
      }

      requestAnimationFrame(() => {
        commit('SET_INVALID_ROW_COUNT', invalidRowCount);
        commit('SET_GUESTS_TO_IMPORT', guestsToImport);
        commit('SET_IS_GENERATING_GUESTS_TO_IMPORT', false);
      });
      // TODO: Return guest counts
      // return Promise.resolve()
    },
  },
};
